<label class="form-label" [for]="config.field">
  {{config.label | translate}}
</label>

<div class="has-validation">
  <input class="form-control" [class.is-invalid]="formControl.invalid" [id]="config.field" [formControl]="formControl"
    [name]="config.field" [placeholder]="config.placeholder || '' | translate"
    [attr.list]="isTextType ? config.field+'list' : ''" [type]="type">

  @if(formControl.hasError("notInSet")){
  <div class="form-text">
    {{"error.notInSet"|translate:{set: config.options} }}
  </div>
  }

  @if(errors){
  @for(error of errors; track $index){
  <div class="invalid-feedback">
    {{ getErrorMessage(error) }}
  </div>
  }
  }

  <!-- @if(isTextType){
  <datalist [id]="config.field+'list'">
    @for(text of config.options; track $index){
    <option [value]="text">
      }
  </datalist>
  } -->

</div>
